import {
    CREATE_ARCHITECTUREREGULATORS,
    RETRIEVE_ARCHITECTUREREGULATORS,
    RETRIEVESINGLE_ARCHITECTUREREGULATORS,
    UPDATE_ARCHITECTUREREGULATORS,
    DELETE_ARCHITECTUREREGULATORS,
  } from "../actions/type";
  const initialState = [];
  function ARCRegulatorsReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case CREATE_ARCHITECTUREREGULATORS:
        return {data: state.data, payload};
      case RETRIEVE_ARCHITECTUREREGULATORS:
        state = (payload.error == 1)?initialState:payload;
        return {data: state, payload};
      case RETRIEVESINGLE_ARCHITECTUREREGULATORS:
        state = (payload.error == 1)?initialState:payload;
        return {data: state.data, payload};
      case UPDATE_ARCHITECTUREREGULATORS:
        return {data: state.data, payload};
      case DELETE_ARCHITECTUREREGULATORS:
        return {data: state.data, payload};
      default:
        return state;
    }
  };
  export {ARCRegulatorsReducer};